import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  border: 1px solid var(--text-secondary);
  border-radius: 4px;
  text-overflow: ellipsis;
`;

type Props = {
  label: string;
};

const FocusAreaTag = ({ label }: Props) => <Container>{label}</Container>;

export default FocusAreaTag;
